import React from "react";
import { Container, SubTitle, Title } from "./styled.components";

const EventsHeader = () => {
  return (
    <Container>
      <Title>Events And Seminars</Title>
      <SubTitle>
        HHH and Sons Presents a Proud Past And Will Keep The Promise
        For Days To Come
      </SubTitle>
    </Container>
  );
};

export default EventsHeader;
